<div class="home-container">
  <!-- Sidenav Component Start -->
  <div class="sidenav-section">
    <app-sidenav [tabs]="tabs"></app-sidenav>
  </div>
  <!-- Sidenav Component End -->
  <div class="right-section">
    <!-- Header Component Start -->
    <app-header></app-header>
    <!-- Header Component End -->
    <!-- Main Content Area Start -->
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
    <!-- Main Content Area End -->
  </div>
</div>
